export default {
  logout: { id: 'logout' },
  profile: { id: 'profile' },
  personalInfo: { id: 'personal_info' },
  notifications: { id: 'notifications' },
  dashboard: { id: 'dashboard' },
  licensees: { id: 'licensees' },
  application: { id: 'application' },
  licensee_application: { id: 'licensee_application' },
  translations: { id: 'translations' },
  sisense: { id: 'sisense_dashboard' },
  site_list: { id: 'site_list' },
  site_group_list: { id: 'site_group_list' },
  user_list: { id: 'user_list' },
  jobs: { id: 'jobs' },
  audit: { id: 'audit' },
  locus_list: { id: 'locus_list' },
  unit_group_list: { id: 'unit_group_list' },
  user_group_list: { id: 'user_group_list' },
  company_name: { id: 'company_name' },
  leaveFeedback: { id: 'leave_feedback' },
  anonymous: { id: 'anonymous' },
  appsStore: { id: 'apps_store' },
  featureFlags: { id: 'feature_flags' },
}
